// extracted by mini-css-extract-plugin
export default {"day":"Day_day__nP5yt","content":"Day_content__SMna-","dayNumber":"Day_dayNumber__aXsWK","otherMonth":"Day_otherMonth__MuUK6","event":"Day_event__KAc0e","today":"Day_today__B39JD"};